import React, { useContext } from 'react';
import classnames from 'classnames';
import { useDeviationViewContext } from '../../Context';
import { SecondaryActionBarContext } from '../ActionBarContext';
import Flex from '../../Flex';
import ViewSwitcher from '../_partials/ViewSwitcher';
import ActionBarStrip from '../_partials/ActionBarStrip';
import PrimaryActionBarIcons, { ExtraIcons, } from '../_partials/PrimaryActionBarIcons';
import DeviationFlags from '../_partials/DeviationFlags';
import FluidMargin from './FluidMargin';
import { useDeviationAttributes } from '../_partials/hooks/useDeviationAttributes';
import s from './ActionBarDesktop.scss';
export var PrimaryActionBarDesktop = function (_a) {
    var deviation = _a.deviation, isOwner = _a.isOwner, className = _a.className, _b = _a.disableBadgeLabel, disableBadgeLabel = _b === void 0 ? false : _b;
    var isTheater = useDeviationViewContext().isTheater;
    var setTopActionBarRef = useContext(SecondaryActionBarContext).setTopActionBarRef;
    var hasFlag = useDeviationAttributes(deviation, isOwner).hasFlag;
    return (React.createElement(ActionBarStrip, { className: classnames(s['root'], className, isTheater ? s['theater'] : s['normal-view']) },
        React.createElement("div", { className: s['icons-wrapper'], ref: setTopActionBarRef },
            React.createElement("div", { className: s['badge'] }, hasFlag && (React.createElement(DeviationFlags, { deviation: deviation, disableLabel: disableBadgeLabel }))),
            React.createElement(FluidMargin, { index: 1 }),
            React.createElement("div", { className: s['icons-middle'] },
                React.createElement(Flex, { alignItems: "center" },
                    React.createElement(PrimaryActionBarIcons, { deviation: deviation, isOwner: isOwner })),
                React.createElement(FluidMargin, { index: 2 }),
                React.createElement(Flex, { alignItems: "center" },
                    React.createElement(ExtraIcons, { deviation: deviation, isOwner: isOwner, printButtonClassName: s['print-button'] }))),
            React.createElement(FluidMargin, { index: 3 }),
            React.createElement(ViewSwitcher, { deviation: deviation, className: s['view-switcher'] }))));
};
PrimaryActionBarDesktop.displayName = 'PrimaryActionBarDesktop';
export default PrimaryActionBarDesktop;
//# sourceMappingURL=PrimaryActionBarDesktop.js.map